module.exports = {
  env: 'preview',
  domain: ['admin-allerhub-dev.allerganaesthetics.cn', 'pan-allerhub-dev.allerganaesthetics.cn'],
  aegisId: 'akNqIsanJXJnMpAhyv',
  reportDomain: 'baike.sparta.html5.qq.com',
  cosAppId: '1304685099',
  bucket: 'tsep-prod-1304685099',
  region: 'ap-guangzhou',
  mobileDomain: 'mb-allerhub-dev.allerganaesthetics.cn',
};
